import { render, staticRenderFns } from "./adddownloadAddress.vue?vue&type=template&id=04113c98&scoped=true&"
import script from "./adddownloadAddress.vue?vue&type=script&lang=js&"
export * from "./adddownloadAddress.vue?vue&type=script&lang=js&"
import style0 from "./adddownloadAddress.vue?vue&type=style&index=0&id=04113c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04113c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04113c98')) {
      api.createRecord('04113c98', component.options)
    } else {
      api.reload('04113c98', component.options)
    }
    module.hot.accept("./adddownloadAddress.vue?vue&type=template&id=04113c98&scoped=true&", function () {
      api.rerender('04113c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/adddownloadAddress.vue"
export default component.exports